export default __webpack_public_path__ + "static/media/I_Indio.faa17d36.mp3";